/**
 * The CMSBlock component
 */
import React from "react";
import CMSBlockFull from "./utils/CMSBlockFull";
import CMSBlockSplit from "./utils/CMSBlockSplit";
import CMSBlockTeaser from "./utils/CMSBlockTeaser";
import CMSBlockSmallTile from "./utils/CMSBlockSmallTile";

const componentForTemplate = (cmsBlock, invert) => {
  switch (cmsBlock.template) {
    case "teaser_tile":
      return <CMSBlockTeaser cmsBlock={cmsBlock} />;
    case 'small_tile':
      return <CMSBlockSmallTile cmsBlock={cmsBlock} />;
    case "image_text_split":
      return <CMSBlockSplit cmsBlock={cmsBlock} invert={invert} />;
    case "fullsize_block":
      return <CMSBlockFull cmsBlock={cmsBlock} />;
    default:
      return <CMSBlockFull cmsBlock={cmsBlock} />;
  }
};
/**
 * Stateless react component to render the CMSBlock page
 * @param {Object} props the props passed to the page.
 */
const CMSBlock = (props) => {
  const { cmsBlock, invert } = props;
  return componentForTemplate(cmsBlock, invert);
};
export default CMSBlock;
